import { useMemo } from "react";

type Entrevistador = {
  id: string;
  curso: string;
  name: string;
  funcao: string;
  online: boolean;
  presencial: boolean;
  place: string;
  email: string;
  telefone: string;
};

type UseEntrevistadoresResult = {
  entrevistadores: Entrevistador[];
};

const mockEntrevistadores: Entrevistador[] = [
  {
    id: "1",
    curso: "3",
    name: "Maria Silva",
    funcao: "Entrevistadora",
    online: true,
    presencial: true,
    place: "Chapecó",
    email: "maria@email.com",
    telefone: "(49) 98765-4321"
  },
  {
    id: "2",
    curso: "4",
    name: "João Santos",
    funcao: "Entrevistador",
    online: true,
    presencial: false,
    place: "Xanxerê",
    email: "joao@email.com",
    telefone: "(49) 99876-5432"
  },
  {
    id: "3",
    curso: "4A",
    name: "Ana Costa",
    funcao: "Facilitadora",
    online: true,
    presencial: true,
    place: "Joaçaba",
    email: "ana@email.com",
    telefone: "(49) 98765-6543"
  },
  {
    id: "4",
    curso: "3",
    name: "Pedro Oliveira",
    funcao: "Entrevistador",
    online: false,
    presencial: true,
    place: "Chapecó",
    email: "pedro@email.com",
    telefone: "(49) 99876-7654"
  },
  {
    id: "5",
    curso: "4",
    name: "Carla Souza",
    funcao: "Entrevistadora",
    online: true,
    presencial: true,
    place: "Xanxerê",
    email: "carla@email.com",
    telefone: "(49) 98765-8765"
  },
  {
    id: "6",
    curso: "4A",
    name: "Lucas Ferreira",
    funcao: "Assistente",
    online: true,
    presencial: false,
    place: "Joaçaba",
    email: "lucas@email.com",
    telefone: "(49) 99876-9876"
  },
  {
    id: "7",
    curso: "3",
    name: "Beatriz Lima",
    funcao: "Entrevistadora",
    online: true,
    presencial: true,
    place: "Chapecó",
    email: "beatriz@email.com",
    telefone: "(49) 98765-0987"
  },
  {
    id: "8",
    curso: "4",
    name: "Felipe Rocha",
    funcao: "Entrevistador",
    online: false,
    presencial: true,
    place: "Xanxerê",
    email: "felipe@email.com",
    telefone: "(49) 99876-1098"
  },
  {
    id: "9",
    curso: "3",
    name: "Camila Martins",
    funcao: "Assistente",
    online: true,
    presencial: true,
    place: "Chapecó",
    email: "camila@email.com",
    telefone: "(49) 98765-1123"
  },
  {
    id: "10",
    curso: "4A",
    name: "Rafael Santos",
    funcao: "Facilitador",
    online: true,
    presencial: false,
    place: "Joaçaba",
    email: "rafael@email.com",
    telefone: "(49) 99876-2134"
  },
  {
    id: "11",
    curso: "4",
    name: "Juliana Costa",
    funcao: "Entrevistadora",
    online: true,
    presencial: true,
    place: "Xanxerê",
    email: "juliana@email.com",
    telefone: "(49) 98765-3245"
  },
  {
    id: "12",
    curso: "3",
    name: "Marcos Pereira",
    funcao: "Entrevistador",
    online: false,
    presencial: true,
    place: "Chapecó",
    email: "marcos@email.com",
    telefone: "(49) 99876-4356"
  },
  {
    id: "13",
    curso: "4A",
    name: "Fernanda Gomes",
    funcao: "Assistente",
    online: true,
    presencial: true,
    place: "Joaçaba",
    email: "fernanda@email.com",
    telefone: "(49) 98765-5467"
  },
  {
    id: "14",
    curso: "4",
    name: "Bruno Silva",
    funcao: "Facilitador",
    online: true,
    presencial: false,
    place: "Xanxerê",
    email: "bruno@email.com",
    telefone: "(49) 99876-6578"
  },
  {
    id: "15",
    curso: "3",
    name: "Laura Ribeiro",
    funcao: "Entrevistadora",
    online: true,
    presencial: true,
    place: "Chapecó",
    email: "laura@email.com",
    telefone: "(49) 98765-7689"
  },
  {
    id: "16",
    curso: "4",
    name: "Gustavo Alves",
    funcao: "Entrevistador",
    online: true,
    presencial: false,
    place: "Xanxerê",
    email: "gustavo@email.com",
    telefone: "(49) 99876-8790"
  },
  {
    id: "17",
    curso: "4A",
    name: "Patrícia Oliveira",
    funcao: "Assistente",
    online: true,
    presencial: true,
    place: "Joaçaba",
    email: "patricia@email.com",
    telefone: "(49) 98765-9801"
  },
  {
    id: "18",
    curso: "3",
    name: "Rodrigo Mendes",
    funcao: "Facilitador",
    online: false,
    presencial: true,
    place: "Chapecó",
    email: "rodrigo@email.com",
    telefone: "(49) 99876-0912"
  },
  {
    id: "19",
    curso: "4",
    name: "Isadora Barbosa",
    funcao: "Entrevistadora",
    online: true,
    presencial: true,
    place: "Xanxerê",
    email: "isadora@email.com",
    telefone: "(49) 98765-1912"
  },
  {
    id: "20",
    curso: "3",
    name: "Thiago Costa",
    funcao: "Entrevistador",
    online: true,
    presencial: false,
    place: "Chapecó",
    email: "thiago@email.com",
    telefone: "(49) 99876-2023"
  },
  {
    id: "21",
    curso: "4A",
    name: "Vanessa Lima",
    funcao: "Assistente",
    online: true,
    presencial: true,
    place: "Joaçaba",
    email: "vanessa@email.com",
    telefone: "(49) 98765-3034"
  },
  {
    id: "22",
    curso: "4",
    name: "André Ferreira",
    funcao: "Facilitador",
    online: true,
    presencial: true,
    place: "Xanxerê",
    email: "andre@email.com",
    telefone: "(49) 99876-4145"
  },
  {
    id: "23",
    curso: "3",
    name: "Natália Santos",
    funcao: "Entrevistadora",
    online: false,
    presencial: true,
    place: "Chapecó",
    email: "natalia@email.com",
    telefone: "(49) 98765-5256"
  },
  {
    id: "24",
    curso: "4",
    name: "Leonardo Sousa",
    funcao: "Entrevistador",
    online: true,
    presencial: true,
    place: "Xanxerê",
    email: "leonardo@email.com",
    telefone: "(49) 99876-6367"
  },
  {
    id: "25",
    curso: "4A",
    name: "Gabriela Mendes",
    funcao: "Assistente",
    online: true,
    presencial: false,
    place: "Joaçaba",
    email: "gabriela@email.com",
    telefone: "(49) 98765-7478"
  },
  {
    id: "26",
    curso: "3",
    name: "Diego Oliveira",
    funcao: "Facilitador",
    online: true,
    presencial: true,
    place: "Chapecó",
    email: "diego@email.com",
    telefone: "(49) 99876-8589"
  },
  {
    id: "27",
    curso: "4",
    name: "Mariana Silva",
    funcao: "Entrevistadora",
    online: true,
    presencial: true,
    place: "Xanxerê",
    email: "mariana@email.com",
    telefone: "(49) 98765-9600"
  },
  {
    id: "28",
    curso: "3",
    name: "Felipe Gomes",
    funcao: "Entrevistador",
    online: false,
    presencial: true,
    place: "Chapecó",
    email: "felinepg@email.com",
    telefone: "(49) 99876-0711"
  },
  {
    id: "29",
    curso: "4A",
    name: "Sophia Ribeiro",
    funcao: "Assistente",
    online: true,
    presencial: true,
    place: "Joaçaba",
    email: "sophia@email.com",
    telefone: "(49) 98765-1722"
  },
  {
    id: "30",
    curso: "4",
    name: "Víctor Alves",
    funcao: "Facilitador",
    online: true,
    presencial: false,
    place: "Xanxerê",
    email: "victor@email.com",
    telefone: "(49) 99876-2833"
  },
  {
    id: "31",
    curso: "3",
    name: "Lucia Pereira",
    funcao: "Entrevistadora",
    online: true,
    presencial: true,
    place: "Chapecó",
    email: "lucia@email.com",
    telefone: "(49) 98765-3844"
  },
  {
    id: "32",
    curso: "4",
    name: "Cristiano Santos",
    funcao: "Entrevistador",
    online: true,
    presencial: true,
    place: "Xanxerê",
    email: "cristiano@email.com",
    telefone: "(49) 99876-4955"
  },
  {
    id: "33",
    curso: "4A",
    name: "Helena Costa",
    funcao: "Assistente",
    online: false,
    presencial: true,
    place: "Joaçaba",
    email: "helena@email.com",
    telefone: "(49) 98765-5966"
  },
  {
    id: "34",
    curso: "3",
    name: "Mateus Oliveira",
    funcao: "Facilitador",
    online: true,
    presencial: true,
    place: "Chapecó",
    email: "mateus@email.com",
    telefone: "(49) 99876-6077"
  },
  {
    id: "35",
    curso: "4",
    name: "Cecilia Martins",
    funcao: "Entrevistadora",
    online: true,
    presencial: false,
    place: "Xanxerê",
    email: "cecilia@email.com",
    telefone: "(49) 98765-7188"
  },
  {
    id: "36",
    curso: "3",
    name: "Leandro Silva",
    funcao: "Entrevistador",
    online: true,
    presencial: true,
    place: "Chapecó",
    email: "leandro@email.com",
    telefone: "(49) 99876-8299"
  },
  {
    id: "37",
    curso: "4A",
    name: "Adriana Gomes",
    funcao: "Assistente",
    online: true,
    presencial: true,
    place: "Joaçaba",
    email: "adriana@email.com",
    telefone: "(49) 98765-8300"
  },
  {
    id: "38",
    curso: "4",
    name: "Rogerio Pereira",
    funcao: "Facilitador",
    online: false,
    presencial: true,
    place: "Xanxerê",
    email: "rogerio@email.com",
    telefone: "(49) 99876-9411"
  },
  {
    id: "39",
    curso: "3",
    name: "Belinda Santos",
    funcao: "Entrevistadora",
    online: true,
    presencial: true,
    place: "Chapecó",
    email: "belinda@email.com",
    telefone: "(49) 98765-9522"
  },
  {
    id: "40",
    curso: "4",
    name: "Augusto Ribeiro",
    funcao: "Entrevistador",
    online: true,
    presencial: false,
    place: "Xanxerê",
    email: "augusto@email.com",
    telefone: "(49) 99876-0533"
  },
  {
    id: "41",
    curso: "4A",
    name: "Rita Alves",
    funcao: "Assistente",
    online: true,
    presencial: true,
    place: "Joaçaba",
    email: "rita@email.com",
    telefone: "(49) 98765-0644"
  },
  {
    id: "42",
    curso: "3",
    name: "Claudio Costa",
    funcao: "Facilitador",
    online: true,
    presencial: true,
    place: "Chapecó",
    email: "claudio@email.com",
    telefone: "(49) 99876-1755"
  },
  {
    id: "43",
    curso: "4",
    name: "Marisa Silva",
    funcao: "Entrevistadora",
    online: false,
    presencial: true,
    place: "Xanxerê",
    email: "marisa@email.com",
    telefone: "(49) 98765-1866"
  },
  {
    id: "44",
    curso: "3",
    name: "Nunzio Rossi",
    funcao: "Entrevistador",
    online: true,
    presencial: true,
    place: "Chapecó",
    email: "nunzio@email.com",
    telefone: "(49) 99876-2977"
  },
  {
    id: "45",
    curso: "4A",
    name: "Olimpia Gomes",
    funcao: "Assistente",
    online: true,
    presencial: false,
    place: "Joaçaba",
    email: "olimpia@email.com",
    telefone: "(49) 98765-3088"
  },
  {
    id: "46",
    curso: "4",
    name: "Paschoal Mendes",
    funcao: "Facilitador",
    online: true,
    presencial: true,
    place: "Xanxerê",
    email: "paschoal@email.com",
    telefone: "(49) 99876-4199"
  },
  {
    id: "47",
    curso: "3",
    name: "Quirino Oliveira",
    funcao: "Entrevistador",
    online: true,
    presencial: true,
    place: "Chapecó",
    email: "quirino@email.com",
    telefone: "(49) 98765-5200"
  },
  {
    id: "48",
    curso: "4",
    name: "Rosalinda Santos",
    funcao: "Entrevistadora",
    online: false,
    presencial: true,
    place: "Xanxerê",
    email: "rosalinda@email.com",
    telefone: "(49) 99876-6311"
  },
  {
    id: "49",
    curso: "4A",
    name: "Silvio Barbosa",
    funcao: "Assistente",
    online: true,
    presencial: true,
    place: "Joaçaba",
    email: "silvio@email.com",
    telefone: "(49) 98765-7422"
  },
  {
    id: "50",
    curso: "3",
    name: "Tatiana Pereira",
    funcao: "Facilitadora",
    online: true,
    presencial: false,
    place: "Chapecó",
    email: "tatiana@email.com",
    telefone: "(49) 99876-8533"
  }
];

export default function useEntrevistadores(): UseEntrevistadoresResult {
  const entrevistadores = useMemo(() => mockEntrevistadores, []);

  return {
    entrevistadores
  };
}
